export const initArrayOfLength = (n) => Array(n)
    .fill(null)
    .map((_, i) => i);
